module.exports = __webpack_public_path__ + "img/pc_p3_z2.10ae985d.png";